module.exports = __webpack_public_path__ + "img/icon3@2x.8036d6ac.png";